import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'

import reports from './modules/reports'

import users from './modules/users'
import accounts from './modules/accounts'
import interaction from './modules/interaction'
import course from './modules/courses'
import questions from './modules/questions'
import student from './modules/student'
import classrooms from "./modules/classrooms";
import other from "./modules/other"

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: true,
  modules: {
      auth,
      reports,
      users,
      interaction,
      course,
      questions,
      student,
      classrooms,
      other,
      accounts,
  },
})
